<template>
  <div class="results-details-bg">
    <div class="results-details">
      <div class="side-menu-box" ref="fixTopComponent">
        <div class="menuFixed">
          <div class="side-menu">
            <a
              class="menu-item flex items-center"
              :class="{
                  active: item.id === menuCurrent,
                }"
              v-for="item in menuList"
              :key="item.id"
              @click="changeMenu($event, item.id)"
            >
              <span>{{ item.label }}</span>
            </a>
          </div>
          <div class="addNew" @click="handleBack"><i class="el-icon-plus" style="font-size: 14px"></i>创建新对话</div>
        </div>
      </div>
      <div class="right-content relative">
        <div class="flex items-start justify-between export-pdf-box" style="height: 36px;">
          <el-button type="text" class="dis-btn" @click="handleOpen">我的指令</el-button>
          <el-button class="export-pdf" :disabled="status !== 'SUCCESS'" :loading="pdfLoading" @click="exportPdf">导出PDF</el-button>
        </div>
        <div class="scroll-content" ref="resultsContainer" @scroll="watchScroll">
          <!-- 思考过程 -->
          <div class="think-content">
            <toggle-component :default-visible="true" style="margin-bottom: 10px" ref="toggleRef1">
              <div class="markdown-body" v-html="thinkingMd"></div>
            </toggle-component>
            <p v-if="startLoading">正在分析...</p>
            <p class="load-text" v-if="thinkLoading"><i class="el-icon-loading"></i></p>
          </div>
          <!-- 流式报告 -->
          <div v-if="reportLoading">
            <div class="content-bg" style="margin-bottom: 0">
              <p>正在生成报告</p>
              <p class="markdown-body" v-html="reporterMd" v-if="reporterMd"></p>
              <p class="load-text" v-if="reportLoading"><i class="el-icon-loading"></i></p>
            </div>
          </div>
          <!-- 报告内容 -->
          <div class="list-container" style="margin-top: 20px" v-show="!isStreaming && resultData">
            <div :id="item.id" v-for="(item) in menuList" :key="item.id" class="list-item">
              <div class="flex no-select">
                <img width="28" height="18" :src="titleLeft" style="margin-right: 2px" alt="">
                <div class="title-bg">
                  <div class="flex justify-center" style="padding: 0 6px">{{ item.label }}</div>
                  <div class="title-bottom"></div>
                </div>
              </div>
              <div class="content-bg" v-loading="loading">
                <el-empty :image-size="140" v-if="!resultData[item.label]" />
                <div v-else>
                  <p class="markdown-body" v-html="resultData[item.label]"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我的指令 dialog-->
    <questionDialog ref="questionDialog" :questionData="question" :documentData="documentName" />
  </div>
</template>

<script>
import titleLeft from '@/assets/images/achievement/detail-title-left.png';
import ToggleComponent from '@/components/ToggleComponent.vue';
import { resultsDetailsMixin } from '@/mixin/resultsAnalysis/resultsMixin';
import questionDialog from '@/views/resultsAnalysis/comps/questionDialog.vue';

export default {
  name: 'resultsDetails',
  mixins: [ resultsDetailsMixin ],
  components: { ToggleComponent, questionDialog },
  data () {
    return {
      titleLeft,
    }
  },
  created () {},
  methods: {},
}
</script>

<style lang="less" scoped>
.results-details-bg {
  width: 100%;
  min-height: calc(100vh - 80px);
  height: calc(100vh - 80px);
  background: linear-gradient(60.33deg, rgba(207, 234, 255, 0.4) 9%, rgba(227, 227, 255, 0.4) 46%, rgba(192, 223, 255, 0.4) 88%);
}
.results-details {
  width: 1240px;
  display: flex;
  padding: 20px 0;
  justify-content: center;
  margin: 0 auto;

  .menuFixed {
    position: fixed;
    top: 100px;
    z-index: 9;
  }

  .side-menu-box {
    width: 180px;
    margin-right: 12px;

    .side-menu {
      width: 180px;
      padding: 12px 0;
      border-radius: 16px;
      overflow: hidden;
      background: url("~@/assets/images/common/menu-bg.png");
      background-size: 100% 100%;
      opacity: .9;

      .menu-item {
        text-align: left;
        padding: 14px 0 14px 23px;
        user-select: none;

        .icon-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 27px;
          height: 22px;
          margin-right: 10px;

          img {
            object-fit: contain;
          }
        }

        span {
          color: rgba(0,0,0,0.85);
          font-size: 14px;
        }
      }

      .active {
        position: relative;
        &:before {
          position: absolute;
          left: 1px;
          content: "";
          width: 4px;
          height: 16px;
          background: #0226E0;
        }
        span {
          font-weight: 500;
          color: #0226E0 !important;
        }
      }
    }

    .addNew {
      cursor: pointer;
      width: 180px;
      height: 44px;
      background-image: url("~@/assets/images/common/btn-bg.png");
      background-size: 100% 100%;
      border-radius: 8px;
      margin-top: 8px;
      display: flex;
      font-size: 14px;
      color: #0226E0;
      align-items: center;
      justify-content: center;
      opacity: .9;
      user-select: none;
      i {
        font-weight: bold;
        margin-right: 8px;
      }
    }
  }

  .bottom-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 60px;
    right: 0;
    left: 0;
    margin: auto;
    color: #8b8b8b;
    cursor: pointer;
    background-color: #ffffff;
    z-index: 999;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.02),
    0 6px 10px 0 rgba(47, 53, 64, 0.1);

    &:hover {
      background-color: #f5f5f5;
    }

    i {
      font-size: 22px;
      font-weight: bold;
    }
  }

  .right-content {
    width: calc(100% - 192px);

    .fs-14 {
      font-size: 14px !important;
    }

    .fs-16 {
      font-size: 16px !important;
    }

    .ml-24 {
      margin-left: 24px;
    }

    .lh-28 {
      line-height: 28px !important;
    }

    .no-select {
      user-select: none;
    }

    .title-bg {
      width: fit-content;
      font-weight: 500;
      font-size: 16px;
      color: #000000;

      .title-bottom {
        height: 6px;
        width: 100%;
        background: rgba(70, 75, 254, 0.3);
        border-radius: 3px;
        margin-top: -3px;
      }
    }

    .list-container {
      .list-item {
        &:last-child {
          .content-bg {
            margin-bottom: 0 !important;
          }
        }
      }
    }

    .content-bg {
      width: inherit;
      margin-bottom: 30px;
      background: #FFFFFF;
      margin-top: 16px;
      padding: 24px 30px;
      border-radius: 8px;

      .content-title {
        font-weight: 500;
        font-size: 18px;
        color: #000000;
      }

      .detail-content {
        margin-top: 18px;

        .content-left {
          font-size: 14px;
          min-width: 85px;
          line-height: 24px;
          color: rgba(0, 0, 0, 0.65);
        }

        .content-right {
          font-size: 14px;
          line-height: 24px;
          color: rgba(0,0,0,0.85);
        }
      }

      .core-index {
        font-weight: 400;
        font-size: 16px;
        color: #464BFE;
      }

      .core-title {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 24px;
      }

      .feasibility-title {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        margin-bottom: 14px;
      }

      .feasibility-top {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 24px;
      }

      .feasibility-content {
        font-weight: 400;
        font-size: 14px;
        color: rgba(0,0,0,0.85);
        line-height: 24px;
      }

      .feasibility-left {
        font-weight: 400;
        font-size: 14px;
        display: flex;
        min-width: 85px;
        align-items: center;
        height: fit-content;
        color: #464BFE;
        line-height: 28px;
      }

      .feasibility-left-bg {
        width: 10px;
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(70, 75, 254, 0.1);
        border-radius: 1px;
        transform: rotateZ(45deg);
        margin-right: 9px;
      }

      .feasibility-left-index {
        width: 4px;
        height: 4px;
        background: #464BFE;
        border-radius: 1px;
      }

      .type-bg {
        background: #F2F5F9;
        border-radius: 8px;
        padding: 16px 20px;
      }
    }

    .achievement-bg {
      width: inherit;
      margin-bottom: 30px;
      background: #FFFFFF;
      margin-top: 16px;
      padding: 10px 0;
      border-radius: 8px;

      .achievement-item {
        padding: 20px 30px;
        //border-bottom: 1px solid #DEE2E9;

        &:first-child {
          margin-top: 0;
        }
        &:last-child {
          border-bottom: none;
        }
      }

      .achievement-title {
        display: flex;
        //align-items: center;
        flex-wrap: wrap;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        margin-bottom: 14px;

        .tag-item {
          background: #FFFFFF;
          border-radius: 2px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: rgba(70, 75, 254, 0.85);
          height: 18px;
          line-height: 18px;
          padding: 0 8px;
          border: 1px solid rgba(70, 75, 254, 0.85);
          margin: 1px 0 1px 8px;
        }
      }

      .achievement-left {
        font-weight: 400;
        min-width: 80px;
        flex-shrink: 0;
        color: rgba(0, 0, 0, 0.65);
        line-height: 24px;
      }

      .achievement-right {
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
      }

      .analysis-btn {
        font-size: 14px;
        font-weight: 500;
        color: rgba(70, 75, 254, 0.85);
        margin-top: 14px;
        cursor: pointer;
        user-select: none;
      }

      .type-bg {
        background: #F2F5F9;
        border-radius: 8px;
        padding: 16px 20px;
      }
    }

  }
  .scroll-content {
    //height: calc(100vh - 120px);
    height: calc(100vh - 154px);
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}

.markdown-body {
  /deep/ table {
    overflow-x: auto;
    thead {
      th {
        min-width: 90px !important;
        text-align: center !important;
      }
    }
    tbody {
      td {
        text-align: center !important;
      }
    }
  }
}


.export-pdf-box {
  /deep/ .el-button {
    &:last-child {
      background: unset !important;
      &.is-loading:before {
        background: unset !important;
      }
      &.is-disabled, &.is-disabled:focus, &.is-disabled:hover {
        span {
          color: #C0C4CC !important;
        }
      }
    }
  }
}

.dis-btn {
  color: #464BFE;
  font-size: 14px;
  border-radius: 4px;
  padding: 6px 12px !important;
  margin-left: 2px;
  background: #464BFE10 !important;
}

.export-pdf {
  width: 110px;
  height: 28px;
  line-height: 28px;
  //width: 180px;
  //height: 44px;
  //line-height: 44px;
  font-size: 14px;
  //color: #FFFFFF;
  color: rgba(2, 38, 224, 0.7);
  padding: 0 !important;
  //background: rgba(2, 38, 224, 0.7);
  background: transparent;
  border-radius: 8px;
  border: none !important;
  user-select: none;
}

.think-content {
  padding: 20px 26px;
  background: #FFFFFF;
  border-radius: 8px;

  /deep/ .toggle-container {
    margin: 0 !important;
    .trigger {
      font-weight: 400 !important;
      color: #333333 !important;
      font-size: 16px !important;
      height: 30px !important;
      line-height: 30px !important;
    }
    .content {
      //margin-top: 8px !important;
    }
  }
}

/deep/ .el-drawer {
  .el-drawer__header {
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    margin-bottom: 0;
    padding-bottom: 16px;
    border-bottom: 1px solid #eeeeee;
  }
}

.analysis-main {
  padding: 10px 30px;
  min-height: 70vh;
}

.load-text {
  font-size: 14px;
  color: rgba(153, 153, 153, 0.9);
  line-height: 20px;
  padding: 4px 0 0;
  i {
    font-size: 18px !important;
    margin-right: 4px;
  }
}

/deep/ .el-loading-mask {
  border-radius: 16px;
}
</style>